import axios from 'axios'
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //此处是增加的代码，设置请求头的类型
const http = axios.create({
  baseURL: window.baseurl,
  // 请求 30s 超时
  // timeout: 300000
})

export default http